import { apiAuthFetch } from '@/api';

import { RefreshTokenParams } from './types';

export const _refreshToken = (body: RefreshTokenParams) => {
  return apiAuthFetch('/refresh-token', {
    method: 'POST',
    body,
  });
};
